import React, { useState, useEffect, forwardRef } from "react";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Moment from 'moment';
import ToggleBtn from './ToggleBtn'
import classes from "./ExposeAndDuedate.module.css";


const ExposeAndDuedate = forwardRef(({ setValid, assessment, handleChangeEnableDraft, handleChangeDueDate }, ref) => {
    const texts = useSelector(state => state.translate.texts);
    const [allowDraft, setAllowDraft] = useState(true)
    // has to be true in order to get right today date
    const [addDueDate, setAddDueDate] = useState(true)
    // refer to the <startDate> only if <addDueDate> is true
    const [startDate, setStartDate] = useState('');

    useEffect(() => {
        setAddDueDate(!!(assessment.dueDate))
        setStartDate(assessment.dueDate)
        setAllowDraft(assessment.allowDraft === false ? false : true)
    }, [])

    const changeEnableDraft = () => {
        setAllowDraft((prevEnableDraft) => {
            handleChangeEnableDraft(!prevEnableDraft)
            return !prevEnableDraft
        })
    }

    const changeAddDueDate = () => {
        setAddDueDate((prevAddDueDate) => {
            if (prevAddDueDate) { // turn off
                handleChangeDueDate(null)
                setValid(true)
            } else { // turn on
                if (!assessment.dueDate && startDate) {
                    handleChangeDueDate(startDate)
                    setValid(true)
                } else { // first time
                    handleChangeDueDate(startDate)
                    setValid(false)
                }
            }
            return !prevAddDueDate
        })
    }

    const changeStartDate = (date) => {
        setStartDate(date)
        setValid(true)
        handleChangeDueDate(Moment(date).format("YYYY-MM-DD 23:59:59"))
    }

    return (
        <div className={classes.ExposeAndDuedate}>
            <div className={classes.Top}>
                <h2 className={classes.ExposeAndDuedateTitle}>{texts.exposeAndDuedateTitle}</h2>
                <div className={classes.Wrapper}>
                    <h3 className={`${classes.EnableDraft} ${classes.Title}`}>{texts.allowDraft}</h3>
                    <ToggleBtn isChecked={allowDraft} onClickFunc={changeEnableDraft} />
                </div>
            </div>
            <div className={classes.Wrapper}>
                <h3 className={`${classes.AddDueDate} ${classes.Title}`}>{texts.addDueDate}</h3>
                <ToggleBtn isChecked={addDueDate} onClickFunc={changeAddDueDate} />
            </div>
            <div className={classes.Calendar}>
                {addDueDate ? <DatePicker
                    inline
                    dateFormat="dd/MM/yy"
                    selected={startDate}
                    onChange={(date) => changeStartDate(date)}
                    minDate={new Date()}
                /> :
                    <DatePicker
                        inline
                        dateFormat="dd/MM/yy"
                        disabled={!addDueDate} // this is not working therefore I did this ->(https://github.com/Hacker0x01/react-datepicker/issues/550)
                        minDate={new Date()}
                        maxDate={new Date().getDate() - 1}
                    />}
            </div>
        </div>
    )
})

export default ExposeAndDuedate